import React from 'react';
import config from '@dataroom/config';
import { useDataroomTenantContext } from '@dataroom/tenant/DataroomTenantContext';
import styles from './exploreTableZeroCase.module.scss';

const ExploreTableZeroCase = () => {
  const { tenant } = useDataroomTenantContext();
  const { supportEmail, name } = config[tenant];

  return (
    <div className={ styles.zeroCaseWrapper }>
      <div>
        <div>
          No { name }s are publicly available at this time.
        </div>
        <br />
        <div>
          If you believe this is a mistake, please contact <a href={ `mailto:${ supportEmail }` } target="_blank">{ supportEmail }</a>.
        </div>
      </div>
    </div>
);
};

export default ExploreTableZeroCase;
